﻿import document from 'document';
import { zenLoginCtaMenu } from './zen-login-cta';
import { zenLoginSelectors as selectors, zenLoginSelectors } from './zen-login-selectors';

export const zenLoginMenu = () => {
    const init = () => {
        const button = document.querySelector(selectors.button);
        const ctaMenu = zenLoginCtaMenu(zenLoginSelectors);

        if (button !== null) {
            ctaMenu.bindEvents(button);
        }

        const mobileButton = document.querySelector(selectors.mobileButton);
        if (mobileButton !== null) {
            ctaMenu.bindMobileEvents(mobileButton);
        }
    };

    return {
        init: init
    };
};
